// removed by extract-text-webpack-plugin
module.exports = {"overlay":"project-popup-module__overlay___33v-U","projectPopup":"project-popup-module__projectPopup___3J1cT","multipleProjects":"project-popup-module__multipleProjects___2nrk9","iconAndName":"project-popup-module__iconAndName___Dhbag","markerIcon":"project-popup-module__markerIcon___2ckXD","closeButton":"project-popup-module__closeButton___2BBVq","multipleButton":"project-popup-module__multipleButton___2lok-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/project-popup/project-popup.module.scss
// module id = 354
// module chunks = 0